import { render, staticRenderFns } from "./DepositZoneForm.vue?vue&type=template&id=1c9e9a16&"
import script from "./DepositZoneForm.vue?vue&type=script&lang=js&"
export * from "./DepositZoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports